module.exports = "<template>\n  <div>\n    Theme: <select v-model=\"selectedTheme\">\n      <option v-for=\"option in defaultThemes\">\n          {{ option }}\n       </option>\n    </select>\n    <vue-tree :theme=\"selectedTheme\"></vue-tree>\n  </div>\n</template>\n\n<script>\nexport default {\n  data () {\n    return {\n      defaultThemes: ['vanilla', 'fontAwesome'],\n      selectedTheme: 'fontAwesome'\n    }\n  },\n  components: {\n    VueTree\n  }\n}\n</script>\n\n<style>\n  select {\n    margin-bottom: 1em\n  }\n</style>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./app/components/examples/DefaultThemes.vue.raw
// module id = yMTO
// module chunks = 1